export default __webpack_public_path__ + "static/media/card02.2ad2fa4e.svg";